import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs/operators';
import {
  JotFormQuestionResponse,
  JotFormPropertyResponse,
  JotFormSubmissionResponse,
} from 'src/app/shared/components/jotform-modal/jotfrom-types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class JotformApiService {
  constructor(private http: HttpClient) {}

  questions(formId: string): Observable<JotFormQuestionResponse> {
    return this.http
      .get<JotFormQuestionResponse>(`/api/jotform/form/${formId}/questions`)
      .pipe(shareReplay());
  }

  formProperties(formId: string): Observable<JotFormPropertyResponse> {
    return this.http
      .get<JotFormPropertyResponse>(`/api/jotform/form/${formId}/properties`)
      .pipe(shareReplay());
  }

  saveSubmissions(
    formId: string,
    data: any
  ): Observable<JotFormSubmissionResponse> {
    return this.http.post<JotFormSubmissionResponse>(
      `/api/jotform/form/${formId}/submissions`,
      data
    );
  }
}
